
import React, { Component } from 'react';

export class FA extends Component {

    render() {
        return (
            <div>
                <h1 align="center">Fevid Acropolis</h1>
                <br />
                <p>This is the main Web Development division of CD, the technologies used here are primarily Javascript based, this site is made with ReactJS but typically we use NextJS</p>
                <h2 align="center">Links</h2>
                <ul>
                    <li><b>Home page </b><a href='https://fevid.vercel.app'>https://fevid.vercel.app,</a></li>
                    <li><b>This website </b><a href='https://circuit-drone.vercel.app'>https://circuit-drone.vercel.app,</a></li>
                    <li><b>MathToCode </b><a href='https://mathtocodegds.vercel.app'>https://mathtocodegds.vercel.app,</a></li>
                    <li><b>Raus nichts </b><a href='https://rausnichts.vercel.app'>https://rausnichts.vercel.app,</a></li>
                    <li><b>client: GDS3 </b><a href='https://gdsimpson3.vercel.app'>https://gdsimpson3.vercel.app,</a></li>
                    <li><b>client: Tepid </b><a href='https://tepid.vercel.app'>https://tepid.vercel.app,</a></li>
                    <li><b>client: ttaksheel </b><a href='https://ttaksheel.vercel.app'>https://ttaksheel.vercel.app,</a></li>
                    <li><b>client: bsw </b><a href='https://bsw9391.vercel.app'>https://bsw9391.vercel.app,</a></li>
                    <li><b>client: Meshwork Analysis </b><a href='https://sourceforge.net/projects/meshwork-analysis-terminal/'>https://sourceforge.net/projects/meshwork-analysis-terminal/,</a></li>
                    <li><b>client: PrimePickZ </b><a href='/'>N/A,</a></li>
                    <li><b>client: KitsuneArt </b><a href='https://kitsune-art.vercel.app/'>https://kitsune-art.vercel.app/,</a></li>
                    <li><b>client: inoetheartist </b><a href='https://inoetheartist.vercel.app/'>https://inoetheartist.vercel.app/,</a></li>
                    <li><b>client: annonymous </b><a href='https://lichens.vercel.app'>https://lichens.vercel.app,</a></li>
                    <li><b>client: annonymous </b><a href='https://narutotivity.vercel.app'>https://narutotivity.vercel.app,</a></li>
                </ul>
            </div>
        );
    }
}

